import React from 'react';
import { AdsChunkSize } from './AdsWithInfiniteScroll.types';
import { AdsSection } from '@/components/AdsSection/AdsSection';
import { ServiceName } from '@/api/types/ads.types';
import { useAdsWithInfiniteScroll } from '@/hooks/useAdsWithInfiniteScroll/useAdsWithInfiniteScroll';
import { useAdsStore } from '@/store/useAdsStore';

export const VipAdsWithInfiniteScroll = () => {
  const [ads, setAds, nextCursor, setNextCursor] = useAdsStore(state => [
    state.ads,
    state.setAds,
    state.nextCursor,
    state.setNextCursor,
  ]);

  const { onLoadMore, adsLoading } = useAdsWithInfiniteScroll({
    adKind: ServiceName.Vip,
    ads,
    setAds,
    nextCursor,
    setNextCursor,
  });

  return (
    <AdsSection
      onLoadMore={onLoadMore}
      ads={ads}
      adsLoading={adsLoading}
      chunkSize={AdsChunkSize.Middle}
      hasTopMargin
    />
  );
};
